import axios from "axios";
import React, { useEffect, useState } from "react";
import { Card, Form } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { useDispatch, useSelector } from "react-redux";
import admin from "../../../assets/images/admin.svg";
import survyor from "../../../assets/images/survyor.svg";
import { error } from "../../../redux/notificationSlice";
import useGeoLocation from "react-ipgeolocation";
import {
  createUser,
  resetUser,
  setUserField,
  updateUser,
  userSelector,
} from "../../../redux/userSlice";

import ClientFields from "../../Form/ClientFields";
import Selectable from "../../Form/Selectable";

const AddNewUser = (props) => {
  const dispatch = useDispatch();
  const location = useGeoLocation();
  const { user } = useSelector(userSelector);
  const [step, setStep] = useState("role");
  const [code, setCode] = useState("");

  const fields = [
    {
      title: "First Name",
      type: "text",
      name: "firstName",
      required: true,
      onChange: (value) => handleChange("firstName", value),
      value: user?.firstName,
    },
    {
      title: "Last Name",
      type: "text",
      required: true,
      name: "lastName",
      onChange: (value) => handleChange("lastName", value),
      value: user?.lastName,
    },
    {
      title: "Email Address",
      type: "email",
      name: "email",
      required: true,
      onChange: (value) => handleChange("email", value),
      value: user?.email,
    },
    {
      title: "Contact Number",
      type: "contact",
      name: "contact",
      required: false,
      code: code,
      onChange: (value) => handleChange("contact", value),
      value: user?.contact,
    },
    {
      title: "Address",
      type: "textarea",
      required: false,
      name: "address",
      onChange: (value) => handleChange("address", value),
      value: user?.address,
    },
  ];

  useEffect(() => {
    setCode(location.country?.toLowerCase());
  }, [location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (step === "role") {
      if (!user?.role) {
        return dispatch(error("Please select user role"));
      }
      setStep("detail");
      return;
    }
    if (user.id) {
      await dispatch(updateUser(user));
      setStep("role");
      return;
    }
    await dispatch(createUser(user));
    setStep("role");
  };

  const handleChange = (field, e) => {
    dispatch(
      setUserField({ field, value: field === "contact" ? e : e.target.value })
    );
  };

  return (
    <Modal
      {...props}
      onHide={() => {
        setStep("role");
        dispatch(resetUser());
        props.onHide();
      }}
      className="modalPopup"
      centered
    >
      <Modal.Header>
        <div className="media-body">
          <h2>{!user?.id ? "Create New User" : "Update User"}</h2>
          {step === "role" ? (
            <p>Choose the role below to start creating a new user</p>
          ) : (
            <p>
              Please fill these fields to{" "}
              {!user?.id ? "create a new user" : "update user"}
            </p>
          )}
        </div>
        <button
          className="cta-text"
          onClick={() => {
            setStep("role");
            dispatch(resetUser());
            props.onHide();
          }}
        >
          Cancel
        </button>
      </Modal.Header>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Modal.Body className="show-grid">
          {step === "role" && (
            <Row>
              <Col lg="6">
                <Card
                  onClick={() =>
                    dispatch(setUserField({ field: "role", value: "admin" }))
                  }
                  className={
                    user?.role === "admin"
                      ? "roleSelection active"
                      : "roleSelection"
                  }
                >
                  <div className="icon">
                    <img src={admin} alt="" />
                  </div>
                  <h3>Admin</h3>
                  <p>A user with all privileges to manage the portal</p>
                </Card>
              </Col>
              <Col lg="6">
                <Card
                  onClick={() =>
                    dispatch(setUserField({ field: "role", value: "surveyor" }))
                  }
                  className={
                    user?.role === "surveyor"
                      ? "roleSelection active"
                      : "roleSelection"
                  }
                >
                  <div className="icon">
                    <img src={survyor} alt="" />
                  </div>
                  <h3>Surveyor</h3>
                  <p>
                    A user which will fill and submit associated surveys only
                  </p>
                </Card>
              </Col>
            </Row>
          )}

          {/*Step 2 Select role*/}

          {step === "detail" && (
            <div className="p-3">
              <Row>
                {fields.map((field, index) => (
                  <ClientFields field={field} index={index} key={index} />
                ))}
              </Row>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <ul className="stepCreate ms-auto">
            <li
              onClick={() => setStep("role")}
              className={step === "role" ? "active" : ""}
            >
              <span> User Role</span>
            </li>
            <li
              onClick={() => setStep("detail")}
              className={step === "detail" ? "active" : ""}
            >
              <span> User Details</span>
            </li>
          </ul>
          <div className="cta-form">
            <button type="submit" className="btn cta-primary">
              {step === "role" ? "Next" : user?.id ? "Update" : "Submit"}
            </button>
          </div>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default AddNewUser;
